'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: calc(100% - 40px);\n  max-width: 1040px;\n  max-height: 100vh;\n  margin: 0px auto;\n  background: ', ';\n  border-radius: 3px;\n  overflow: hidden;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);\n  transform: ', ';\n  ', ';\n  ', ';\n'], ['\n  width: calc(100% - 40px);\n  max-width: 1040px;\n  max-height: 100vh;\n  margin: 0px auto;\n  background: ', ';\n  border-radius: 3px;\n  overflow: hidden;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);\n  transform: ', ';\n  ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    width: 100%;\n    padding: 0px;\n  '], ['\n    width: 100%;\n    padding: 0px;\n  ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _media = require('../../../libs/media');

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Libs
// Colors


var FilePreviewCard = _styledComponents2.default.div(_templateObject, _colors.white, function (_ref) {
  var visible = _ref.visible;
  return visible ? 'none' : 'translateY(-50px)';
}, (0, _polished.transitions)('transform .3s ease-in-out'), _media.media.s(_templateObject2));

exports.default = FilePreviewCard;